export type InvoiceTab = 'quotes' | 'outgoing' | 'incoming';

const TAB_TO_SLUG: Record<InvoiceTab, string> = {
  quotes: 'quotes',
  outgoing: 'outgoing',
  incoming: 'incoming',
};

const SLUG_TO_TAB = Object.fromEntries(
  (Object.entries(TAB_TO_SLUG) as [InvoiceTab, string][]).map(([tab, slug]) => [slug, tab]),
) as Record<string, InvoiceTab>;

export function invoiceTabSlug(tab: InvoiceTab): string {
  return TAB_TO_SLUG[tab];
}

export function invoiceTabFromSlug(slug: string | undefined): InvoiceTab | null {
  if (!slug) return null;
  return SLUG_TO_TAB[slug] ?? null;
}

export function invoicesOverviewPath(instanceId: string, tab: InvoiceTab): string {
  return `/i/${instanceId}/invoices/${invoiceTabSlug(tab)}`;
}
